import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { Prevalence } from './prevalence.enum';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-frequency-view',
  standalone: true,
  imports: [
    NgIf,
    TranslocoDirective
  ],
  templateUrl: './frequency-view.component.html',
  styleUrl: './frequency-view.component.scss'
})
export class FrequencyViewComponent implements OnInit {
  @Output() selectedFrequencyChange = new EventEmitter<Prevalence>();
  @Input() selectedFrequency: Prevalence | undefined;
  @Input() public showErrorMessage: boolean = false;
  protected isValid: boolean = false;
  protected readonly prevalence = Prevalence;

  ngOnInit() {
    this.isValid = !!this.selectedFrequency;
  }

  protected selectType(type: Prevalence): void {
    this.selectedFrequency = type;
    this.isValid = !!this.selectedFrequency;
    this.selectedFrequencyChange.emit(type);
  }
}
